module.exports = __webpack_public_path__ + "background.jpg?69317484005955a5a01047e39a0f2164";